import { render, staticRenderFns } from "./CreateBill.vue?vue&type=template&id=52957b74"
import script from "./CreateBill.vue?vue&type=script&lang=js"
export * from "./CreateBill.vue?vue&type=script&lang=js"
import style0 from "./CreateBill.vue?vue&type=style&index=0&id=52957b74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports